import { render, staticRenderFns } from "./RequestMobile.vue?vue&type=template&id=cd59fff0"
import script from "./RequestMobile.vue?vue&type=script&lang=ts"
export * from "./RequestMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports